import React from 'react';

class Separator extends React.Component {
	render() {
		return (
			<div style={{
				backgroundColor: '#D2D2D2',
				height: 1,
				marginLeft: 16
			}}>
			</div>
		)
	}
}

export default Separator;


// WEBPACK FOOTER //
// ./src/components/separator.jsx